export const SET_DATA = "SET_DATA";
export const SAVE_PROPERTY_DETAILS = "SAVE_PROPERTY_DETAILS";
